export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('LEAST_ONE_PRODUCT') !== -1) {
      messages.push({
        message: 'editCommandeTlpe.messages.error.oneProduct',
      });
    }
    if (message.indexOf('START_DATE_GREATER_THAN_END_DATE') !== -1) {
      messages.push({
        message: 'validation.dateDebutGreaterDateFin',
      });
    }
    if (message.indexOf('INVALID_FOR_CALC') !== -1) {
      messages.push({
        message: 'editCommandeTlpe.messages.error.lineNotValidForCalc',
      });
    }
  });
}
